window.getSubgenero = function(id) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.ajax({
        url: 'subgeneros/get',
        type: 'GET',
        data: { id:id },
        dataType: 'json',
        success: function (data) {


            let inputHiddenId = `<input type="hidden" id ="genero_id" value ="${id}">`;
            let table = `
            
                <table class="w-full text-left" id="tabla-subgeneros">
                    <thead>
                        <tr>
                            <th class=" px-3 py-2">Orden</th>
                            <th class=" px-3 py-2">Nombre</th>
                            <th class=" px-3 py-2">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
            `;
              
            data.forEach(sub => {
                table += `
                    <tr id="row-${sub.id}">
                        <td class=" px-3 py-2" id="orden-${sub.id}">${sub.orden ?? '0'}</td>
                        <td class=" px-3 py-2" id="nombre-${sub.id}">${sub.nombre}</td>
                        <td class=" px-3 py-2">
                        
                            <button onclick="editarSub(${sub.id})" class="p-1 rounded hover:bg-blue-100">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="#fff"
                                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                    class="w-6 h-6 stroke-cyan-500">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                </svg>
                            </button>

                            <button class="bg-red-500 text-white px-2 py-1 rounded"
                                onclick="borrarSub(${sub.id})">  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 stroke-red-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                      </svg></button>
                        </td>
                    </tr>
                `;
            });

            table += `</tbody></table>`;
           
            table += `${inputHiddenId}`;

            
            $('#content-subgenero').html(table);
        },
        error: function (data) {
            console.log(data);
        }
    });
};


// Función para editar
window.editarSub = function(id) {
    let td = document.getElementById(`nombre-${id}`);
    let orden = document.getElementById(`orden-${id}`);
    let nombreActual = td.innerText;
    let ordenActual = orden.innerText;

    td.innerHTML = `<input type="text" id="edit-nombre-${id}" value="${nombreActual}" class="border rounded px-2 py-1 w-full"/>`;
    orden.innerHTML = `<input type="text" id="edit-orden-${id}" value="${ordenActual}" class="border rounded px-2 py-1 w-full"/>`;

    let row = document.getElementById(`row-${id}`);
    let btn = row.querySelector('button[onclick^="editarSub"]');
    btn.innerText = "Guardar";
    btn.setAttribute("onclick", `guardarSub(${id})`);
};


window.guardarSub = function(id = null) {
    let nuevoNombre;
    let nuevoOrden;
    let generoId = $('#genero_id').val() || null; 

    if (id) {
        nuevoNombre = document.getElementById(`edit-nombre-${id}`).value;
        nuevoOrden = document.getElementById(`edit-orden-${id}`).value;
    } else {
        nuevoNombre = document.getElementById(`nuevo-subgenero`).value;
    }

    $.ajax({
        url: 'subgeneros/save',
        type: 'POST',
        data: { id: id, nombre: nuevoNombre, genero_id: generoId, orden: nuevoOrden},
        success: function(response) {
            if (response.success) {
                if (id) {
                    document.getElementById(`nombre-${id}`).innerText = nuevoNombre;
                    document.getElementById(`orden-${id}`).innerText = nuevoOrden;
                    let row = document.getElementById(`row-${id}`);
                    let btn = row.querySelector('button[onclick^="guardarSub"]');
                    btn.innerText = "Editar";
                    btn.setAttribute("onclick", `editarSub(${id})`);
                    ordenarTablaPorOrden();
                } else {
                    let sub = response.data;
                    let nuevaFila = `
                        <tr id="row-${sub.id}">
                            <td class="border px-3 py-2" id="orden-${sub.id}">${sub.id}</td>
                            <td class="border px-3 py-2" id="nombre-${sub.id}">${sub.nombre}</td>
                            <td class="border px-3 py-2">
                                <button onclick="editarSub(${sub.id})" class="p-1 rounded hover:bg-blue-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff"
                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                        class="w-6 h-6 stroke-cyan-500">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                    </svg>
                                </button>
                                <button onclick="borrarSub(${sub.id})" class="bg-red-500 text-white px-2 py-1 rounded"> <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 stroke-red-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                      </svg></button>
                            </td>
                        </tr>
                    `;
                    $('#tabla-subgeneros tbody').append(nuevaFila);
                    $('#nuevo-subgenero').val('');
                     $('#modalAddSubgenerosBO').hide('');
                }
            } else {
                alert("Error: " + response.message);
            }
        },
        error: function(xhr) {
            console.log(xhr.responseText);
            alert("Ocurrió un error al guardar el subgénero.");
        }
    });
};

window.ordenarTablaPorOrden = function() {
    let tbody = $('#tabla-subgeneros tbody');
    let filas = tbody.find('tr').get();

    filas.sort(function(a, b) {
        let ordenA = parseInt($(a).find('td[id^="orden-"]').text(), 10);
        let ordenB = parseInt($(b).find('td[id^="orden-"]').text(), 10);
        return ordenA - ordenB;
    });

    $.each(filas, function(index, row) {
        tbody.append(row);
    });
}



window.borrarSub = function(id) {
    $.ajax({
        url: 'subgeneros/delete',
        type: 'POST',
        data: { id:id },
        success: function() {
            document.getElementById(`row-${id}`).remove();
        }
    });
};
